// dynamic-filter-section.js
class DynamicFilterSection {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sectionId = sectionElement.dataset.sectionId;
    this.init();
  }
  
  init() {
    this.applyBackgroundImages();
    this.applyContainerStyles();
    this.applyButtonStyles();
    this.setContainerPosition();
  }
  
  applyBackgroundImages() {
    const backgroundElement = this.section.querySelector('.filter-background');
    if (!backgroundElement) return;
    
    // Obtener URLs de las imágenes desde data attributes
    const desktopImage = this.section.dataset.backgroundImageDesktop;
    const mobileImage = this.section.dataset.backgroundImageMobile;
    
    // Aplicar imagen de desktop
    if (desktopImage && desktopImage !== '') {
      backgroundElement.style.backgroundImage = `url('${desktopImage}')`;
    }
    
    // Aplicar imagen de móvil via media query
    if (mobileImage && mobileImage !== '') {
      const mobileStyle = document.createElement('style');
      mobileStyle.textContent = `
        @media (max-width: 768px) {
          .dynamic-filter-section[data-section-id="${this.sectionId}"] .filter-background {
            background-image: url('${mobileImage}') !important;
          }
        }
      `;
      document.head.appendChild(mobileStyle);
    }
  }
  
  applyContainerStyles() {
    const filterRow = this.section.querySelector('.filter-row');
    if (!filterRow) return;
    
    const backgroundColor = this.section.dataset.containerBackground;
    const borderColor = this.section.dataset.containerBorder;
    
    if (backgroundColor && backgroundColor !== '') {
      filterRow.style.backgroundColor = backgroundColor;
    }
    
    if (borderColor && borderColor !== '') {
      filterRow.style.border = `2px solid ${borderColor}`;
    }
  }
  
  applyButtonStyles() {
    const button = this.section.querySelector('.search-button');
    if (!button) return;
    
    const bgColor = this.section.dataset.buttonBackground;
    const bgColorSecondary = this.section.dataset.buttonBackgroundSecondary;
    const textColor = this.section.dataset.buttonTextColor;
    
    // Aplicar fondo (gradiente o sólido)
    if (bgColor) {
      if (bgColorSecondary && bgColorSecondary !== '') {
        button.style.background = `linear-gradient(135deg, ${bgColor}, ${bgColorSecondary})`;
      } else {
        button.style.background = bgColor;
      }
    }
    
    // Aplicar color de texto
    if (textColor && textColor !== '') {
      button.style.color = textColor;
    }
  }
  
  setContainerPosition() {
    const filterRow = this.section.querySelector('.filter-row');
    if (!filterRow) return;
    
    const position = this.section.dataset.containerPosition || 'center';
    filterRow.setAttribute('data-position', position);
    
    // Ajustar max-width basado en la posición
    if (position === 'left' || position === 'right') {
      filterRow.style.maxWidth = '800px';
    } else {
      filterRow.style.maxWidth = '';
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.dynamic-filter-section');
  
  sections.forEach(section => {
    new DynamicFilterSection(section);
  });
});

// Para secciones dinámicas de Shopify
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function(e) {
    const section = e.target.querySelector('.dynamic-filter-section');
    if (section) {
      new DynamicFilterSection(section);
    }
  });
}